import React from 'react';
import LinkItem from './Link';
import DropdownItem from './Dropdown';
import OnClickItem from './OnClick';

const NavItem = ({
  variant,
  component,
  agentResource,
  ...rest
}) => {
  const { to } = rest;

  const getVariant = () => {
    let v;
    if (typeof variant === 'function') {
      v = variant({ agentResource });
    } else {
      v = variant;
    }
    return v;
  };

  const navItemVariant = getVariant();

  switch (navItemVariant) {
    case 'link':
      return (
        <LinkItem
          {...rest}
        />);
    case 'onClick':
      return (
        <OnClickItem
          {...rest}
        />);
    case 'dropdown':
      return (
        <DropdownItem
          {...rest}
        />);
    case 'custom':
      const CustomItem = component; // eslint-disable-line
      return (
        <CustomItem
          {...rest}
        />);
    default:
      throw new Error(`Variant "${variant}" not supported as a NavItem on "${to}" REST = ${JSON.stringify(rest)}. Must be one of: dropdown, link, onClick, or custom.`);
  }
};

export default NavItem;
